import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28c093c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "infinite-list rel",
  style: {"overflow":"auto"},
  "infinite-scroll-immediate": false,
  "infinite-scroll-distance": 100
}
const _hoisted_2 = { class: "brand-background flex-col-ter" }
const _hoisted_3 = { class: "brand-background-title" }
const _hoisted_4 = { class: "brand-background-desc" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "viewport pt_10" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"300px","width":"100%"} }, null, -1))
const _hoisted_8 = { class: "brand rel" }
const _hoisted_9 = { class: "viewport" }
const _hoisted_10 = { class: "brand-label" }
const _hoisted_11 = {
  key: 0,
  class: "brand-list"
}
const _hoisted_12 = {
  key: 1,
  class: "flex-cen-ter noSearchData"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/brand/brand_noSearchData.png",
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { ref, watch, reactive, computed, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import ListLabel from './../components/ListLabel.vue'
import BrandCard from './../components/BrandCard.vue'
import { useRoute, useRouter } from 'vue-router'
import { brandQueryList, brandSearch } from '@/apis/brand'
import { useRtfix } from '@/store'

interface brandItem {
  brandId: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const routeName = useRoute().name?.toString() ?? ''

const noSearchData = ref(false)

const brandList = ref<brandItem[]>([])
const page = ref({
  pageNum: 1,
  pageSize: 4
})
const filterData = ref({})
const getBrandList = () => {
  const params = {
    ...page.value,
    ...filterData.value,
    ...route.query
  }
  const api = route.query.keyword ? brandSearch : brandQueryList
  api(params).setSite(res => {
    console.log(res)
    if (res.data.records.length) {
      brandList.value = brandList.value.concat(res.data.records)
      page.value.pageNum += 1
      noSearchData.value = false
    } else {
      noSearchData.value = true
    }
  }).catch(() => {
    noSearchData.value = true
  })
}

const search = (updateFilterData) => {
  page.value.pageNum = 1
  brandList.value = []
  filterData.value = updateFilterData
  getBrandList()
}

const name = route.name
watch(route, (v) => {
  if (v.name !== name) return
  page.value.pageNum = 1
  brandList.value = []
  getBrandList()
})

getBrandList()


return (_ctx: any,_cache: any) => {
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('什么是品牌集')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          innerHTML: _unref(t)(`品牌集的优势 用户可以获得哪些权益，在品牌集购买商品有什么优惠等等`)
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(ListLabel, { search: search })
          ]),
          (brandList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandList.value, (i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i.brandId,
                    class: "infinite-list-item"
                  }, [
                    _createVNode(BrandCard, {
                      data: i,
                      source: "list"
                    }, null, 8, ["data"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (noSearchData.value && brandList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512)), [
    [_directive_infinite_scroll, getBrandList]
  ])
}
}

})